// Beloulash mockup interactivity — light & vanilla, no build step.
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // --- Mobile drawer ---
  const drawer = $('#site-drawer');
  if (drawer) {
    const open = $('#open-nav');
    const close = $('#close-nav');
    const toggle = (state) => drawer.classList.toggle('open', state);
    open && open.addEventListener('click', () => toggle(true));
    close && close.addEventListener('click', () => toggle(false));
    drawer.addEventListener('click', (e) => { if (e.target === drawer) toggle(false); });
    $$('.drawer-nav a', drawer).forEach(a => a.addEventListener('click', () => toggle(false)));
  }

  // --- Tier picker (PDP) ---
  $$('.tier-list').forEach(list => {
    const radios = $$('input[type="radio"]', list);
    const sync = () => {
      $$('.tier', list).forEach(t => t.classList.toggle('is-active', t.querySelector('input').checked));
      const checked = radios.find(r => r.checked);
      if (checked) {
        const price = checked.dataset.price;
        $$('[data-bind="price"]').forEach(el => el.textContent = price);
      }
    };
    radios.forEach(r => r.addEventListener('change', sync));
    sync();
  });

  // --- Style chips ---
  $$('[data-chips]').forEach(group => {
    $$('.chip', group).forEach(chip => {
      chip.addEventListener('click', () => {
        $$('.chip', group).forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      });
    });
  });

  // --- Quantity ---
  $$('.qty').forEach(q => {
    const input = $('input', q);
    const minus = q.querySelector('[data-act="minus"]');
    const plus = q.querySelector('[data-act="plus"]');
    minus && minus.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    plus && plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  // --- Newsletter mock ---
  $$('form[data-newsletter]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      form.innerHTML = '<p style="margin:0;color:#fff;">Bedankt! Check je inbox voor je welkomstcode.</p>';
    });
  });

  // --- Age gate (simple, sessionStorage) ---
  const gate = $('#age-gate');
  if (gate && !sessionStorage.getItem('age-ok')) {
    gate.style.display = 'grid';
    $('#age-yes')?.addEventListener('click', () => {
      sessionStorage.setItem('age-ok', '1');
      gate.style.display = 'none';
    });
    $('#age-no')?.addEventListener('click', () => {
      window.location.href = 'https://www.google.com';
    });
  }
})();
